import { apiGet, apiPost } from './api';

// ---- Платежи ----
export type PayRowOv = {
  deal_id: number;
  no: string;
  client: string;
  contract_no: string | null;
  pay_id: number;
  seq: number;
  label: string;
  amount: number;
  paid_amount: number;
  paid_ref: string | null;
  due_offset: number;
  due_date: string | null;
  paid: number;
  state: string;
};
export type PayOverview = {
  kpi: { debitor: number; overdue: number; soon: number };
  rows: PayRowOv[];
};
export const payOverview = () => apiGet<PayOverview>('/api/pay/overview');
// Отметка оплаты с экрана «Платежи»: { amount, ref } — частичная/полная; {} — полная.
// Откат отсюда НЕДОСТУПЕН (только из карточки сделки) — { paid:false } не передаём.
export const markPayById = (
  dealId: number,
  payId: number,
  body: { amount?: number; ref?: string } = {},
) => apiPost(`/api/deals/${dealId}/pay/${payId}/mark`, body);

// ---- Производство ----
export type CehCard = { id: string; name: string; descr: string; avg: number };
export type ProdDeal = {
  id: number;
  no: string;
  client: string;
  stage: number;
  otk: number;
  units: number;
  ceh: Record<string, number>;
  prodPct: number;
};
export type PipeStation = {
  ico: string;
  name: string;
  value: string;
  pct: number;
  warn?: boolean;
  ceh?: string;
  go?: string;
};
export type GanttRow = {
  id: number;
  no: string;
  client: string;
  sum: number | null;
  start: number;
  ship: number;
  prodPct: number;
  warn: boolean;
};
export type Gantt = { weeks: number; back: number; rows: GanttRow[] };
export type ProdOverview = {
  cehs: CehCard[];
  deals: ProdDeal[];
  pipeline: PipeStation[];
  gantt: Gantt;
};
export const prodOverview = () => apiGet<ProdOverview>('/api/prod/overview');
export const setCehProg = (dealId: number, cehId: string, delta: number) =>
  apiPost<{ ok: boolean; prog: number }>(`/api/prod/deal/${dealId}/ceh/${cehId}`, { delta });

export type CehItem = { id: number; name: string; qty: number; prog: number };
export type CehDeal = {
  deal_id: number;
  no: string;
  client: string;
  ceh_prog: number;
  items: CehItem[];
};
export type CehDrill = { ceh: { id: string; name: string; descr: string }; deals: CehDeal[] };
export const cehDrill = (id: string) => apiGet<CehDrill>(`/api/prod/ceh/${id}`);
export const setItemProg = (itemId: number, delta: number) =>
  apiPost<{ ok: boolean; prog: number }>(`/api/prod/item/${itemId}/prog`, { delta });
export const setOtk = (dealId: number, otk: boolean) =>
  apiPost(`/api/prod/deal/${dealId}/otk`, { otk });

// ---- Штрихкод-прослеживаемость ----
export type Component = { id: number; name: string; qty: number; barcode: string; status: string };
export const itemComponents = (itemId: number) =>
  apiGet<{ components: Component[] }>(`/api/prod/item/${itemId}/components`);
export const compReceive = (compId: number) => apiPost(`/api/prod/comp/${compId}/receive`);
export const compIssue = (compId: number) => apiPost(`/api/prod/comp/${compId}/issue`);

export type ScanResult = {
  ok: boolean;
  found: boolean;
  message?: string;
  name?: string;
  item?: string;
  deal?: string;
  client?: string;
  status?: string;
  action?: string;
};
export const scanBarcode = (barcode: string) => apiPost<ScanResult>('/api/prod/scan', { barcode });
